module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerProcedimento
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    attrs: {
      "show-text-danger-procedimento": _vm.showTextDangerProcedimento,
      "nomeProcedimento": _vm.dados.procedimento.nome
    },
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerPreparo
    }
  }, [_vm._v("Preparo")]), _vm._v(" "), _c('select-preparo', {
    attrs: {
      "show-text-danger-preparo": _vm.showTextDangerPreparo,
      "nomePreparo": _vm.dados.preparo.nome
    },
    on: {
      "setPreparoSelecionado": function (preparoSelecionado) {
        _vm.setPreparoSelecionado(preparoSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerValor
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerValor
    }
  }, [_vm._v("Valor (R$)")]), _vm._v(" "), _c('money', _vm._b({
    ref: "valor",
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.dados.valor),
      callback: function($$v) {
        _vm.$set(_vm.dados, "valor", $$v)
      },
      expression: "dados.valor"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerTipoLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipoLimite
    }
  }, [_vm._v("Tipo de Limite")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_limite),
      expression: "dados.tipo_limite"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": false,
      "placeholder": "Selecione"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_limite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.procedimentoSelecionado.tipo_atendimento == 0) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Procedimento")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), (_vm.procedimentoSelecionado.tipo_atendimento == 0) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Geral")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerLimite
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimite
    }
  }, [_vm._v("Limite Físico")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite.quantidade),
      expression: "dados.limite.quantidade"
    }],
    ref: "limite_fisico",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.dados.tipo_limite == 0 ? false : true,
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite.quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados.limite, "quantidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Valor Total (R$)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": _vm._f("numberFormat")(_vm.controle.limite_financeiro, 2, ',', '.')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": false,
      "placeholder": "Selecione"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Procedimento do Contrato")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1aa8968a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/distribuicoes/contratos/contratoProcedimentoForm.vue
// module id = 808
// module chunks = 0